import { render, staticRenderFns } from "./ImportTables.vue?vue&type=template&id=2490c363&scoped=true&"
import script from "./ImportTables.vue?vue&type=script&lang=js&"
export * from "./ImportTables.vue?vue&type=script&lang=js&"
import style0 from "./ImportTables.vue?vue&type=style&index=0&id=2490c363&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490c363",
  null
  
)

export default component.exports